import styled from 'styled-components';

import { colors } from '~/styles/colors';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
`;

export const Card = styled.div`
  margin-top: 15px;
  border-radius: 8px;
  padding: 12px 24px 32px;
  border: 1px solid ${colors.GreyDefaultCardBorder};
  border-top: 10px solid ${colors.brand.principal};
`;

export const PictureBox = styled.div`
  display: flex;
  width: 280px;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-radius: 4px;
`;

export const ContainerSelect = styled.div`
  > div {
    > div:first-of-type {
      border: 1px solid ${colors.GreyDefaultCardBorder};
    }
  }
`;

export const ToggleContainer = styled.div`
  padding: 0 0 20px;
`;
